"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CanvasObject = void 0;
var _CanvasObject = require("../../../CanvasInterface/Objects/CanvasObject");
var _Calc2D = require("../../../Utils/Calc2D");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var CanvasObject = exports.CanvasObject = /*#__PURE__*/function (_AbstractCanvasObject) {
  _inherits(CanvasObject, _AbstractCanvasObject);
  var _super = _createSuper(CanvasObject);
  function CanvasObject(options) {
    var _this;
    _classCallCheck(this, CanvasObject);
    _this = _super.call(this, options);
    _defineProperty(_assertThisInitialized(_this), "triggerChangeEvent", function (prevState) {
      _this._observable.triggerEvent(_CanvasObject.CanvasObjectEvents.OnChange, {
        prevState: prevState
      });
    });
    return _this;
  }
  _createClass(CanvasObject, [{
    key: "getOptionsFromWrappedObject",
    value: function getOptionsFromWrappedObject() {
      var o = this.wrappedObject;
      return {
        x: o.position.x,
        y: o.position.y,
        rotation: o.rotation,
        scaling: o.scaling.x
      };
    }
  }, {
    key: "setPosition",
    value: function setPosition(x, y) {
      var o = this.wrappedObject;
      o.position.x = x;
      o.position.y = y;
    }
  }, {
    key: "setRotation",
    value: function setRotation(rotation) {
      var o = this.wrappedObject;
      o.applyMatrix = false;
      o.rotation = rotation;
    }
  }, {
    key: "setScaling",
    value: function setScaling(scaling) {
      var o = this.wrappedObject;
      o.applyMatrix = false;
      o.scaling.x = scaling;
      o.scaling.y = scaling;
    }
  }, {
    key: "setSelected",
    value: function setSelected(selected) {
      var o = this.wrappedObject;
      o.selected = selected;
    }
  }, {
    key: "initObjectEvents",
    value: function initObjectEvents() {
      //do nothing
    }
  }, {
    key: "getTransformedRect",
    value: function getTransformedRect() {
      var o = this.wrappedObject;
      var internalBounds = o.internalBounds,
        bounds = o.bounds,
        rotation = o.rotation,
        scaling = o.scaling;
      var width = internalBounds.width,
        height = internalBounds.height;
      var center = bounds.center;
      var zoom = o.getView().getZoom();
      var scaledX = center.x * zoom;
      var scaledY = center.y * zoom;
      var scaledWidth = width * scaling.x * zoom;
      var scaledHeight = height * scaling.y * zoom;
      return {
        left: scaledX - scaledWidth / 2,
        top: scaledY - scaledHeight / 2,
        width: scaledWidth,
        height: scaledHeight,
        rotation: rotation,
        center: {
          x: scaledX,
          y: scaledY
        },
        get topRight() {
          var x = this.left + this.width;
          var y = this.top;
          var _this$center = this.center,
            cx = _this$center.x,
            cy = _this$center.y;
          return (0, _Calc2D.transformPoint)(x, y, cx, cy, this.rotation);
        },
        get bottomRight() {
          var x = this.left + this.width;
          var y = this.top + this.height;
          var _this$center2 = this.center,
            cx = _this$center2.x,
            cy = _this$center2.y;
          return (0, _Calc2D.transformPoint)(x, y, cx, cy, this.rotation);
        },
        get bottomLeft() {
          var x = this.left;
          var y = this.top + this.height;
          var _this$center3 = this.center,
            cx = _this$center3.x,
            cy = _this$center3.y;
          return (0, _Calc2D.transformPoint)(x, y, cx, cy, this.rotation);
        },
        get topLeft() {
          var x = this.left;
          var y = this.top;
          var _this$center4 = this.center,
            cx = _this$center4.x,
            cy = _this$center4.y;
          return (0, _Calc2D.transformPoint)(x, y, cx, cy, this.rotation);
        }
      };
    }
  }, {
    key: "getCenter",
    value: function getCenter() {
      var o = this.wrappedObject;
      var zoom = o.getView().getZoom();
      var _o$bounds$center$mult = o.bounds.center.multiply(zoom),
        x = _o$bounds$center$mult.x,
        y = _o$bounds$center$mult.y;
      return {
        x: x,
        y: y
      };
    }
  }, {
    key: "remove",
    value: function remove() {
      _get(_getPrototypeOf(CanvasObject.prototype), "remove", this).call(this);
      this.wrappedObject.remove();
    }
  }, {
    key: "wrappedObjectToObject",
    value: function wrappedObjectToObject() {
      var obj = this.wrappedObject.exportJSON({
        asString: false
      });
      delete obj.selected;
      return obj;
    }
  }, {
    key: "getBoundSize",
    value: function getBoundSize() {
      var _this$wrappedObject$b = this.wrappedObject.bounds,
        height = _this$wrappedObject$b.height,
        width = _this$wrappedObject$b.width;
      return {
        height: height,
        width: width
      };
    }
  }, {
    key: "getSize",
    value: function getSize() {
      var _this$wrappedObject$i = this.wrappedObject.internalBounds,
        height = _this$wrappedObject$i.height,
        width = _this$wrappedObject$i.width;
      return {
        height: height,
        width: width
      };
    }
  }]);
  return CanvasObject;
}(_CanvasObject.AbstractCanvasObject);